import React, { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import FieldNoteDetails from "./FieldNoteDetails";
import FieldNoteHeader from "./FieldNoteHeader";

const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function FieldNoteWrap() {
  const { slug } = useParams();
  const [fieldNote, setFieldNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchFieldNote = async () => {
      setLoading(true);
      setError(null);
      setFieldNote(null);

      try {
        const apiUrl = `${process.env.REACT_APP_API_FOLDER}get_fieldnote/?slug=${encodeURIComponent(slug)}`;
        const response = await axios.get(apiUrl, {
          headers: { "X-API-TOKEN": API_TOKEN },
        });

        if (cancelled) return;

        if (response.data && response.data.error) {
          setError(response.data.error);
        } else {
          setFieldNote(response.data);
        }
      } catch (requestError) {
        if (!cancelled) {
          setError(requestError.message || "Failed to load this Field Note.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchFieldNote();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) {
    return (
      <div className="package-details-wrapper pt-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <Skeleton height={70} />
              <div className="mt-30">
                <Skeleton height={420} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !fieldNote) {
    return (
      <div className="package-details-wrapper pt-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h2 className="has-bg-image">Field Note unavailable</h2>
              <p className="has-bg-image mt-20">{error || "This Field Note could not be found."}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="package-details-wrapper pt-110">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="tour-package-details">
              <FieldNoteHeader fieldNote={fieldNote} />
              <FieldNoteDetails fieldNote={fieldNote} />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="package-sidebar" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FieldNoteWrap;
